module.exports = "<div class=\"py-4\"><todo-estate estate=\"$ctrl.item.record\"></todo-estate></div>";